import React from "react";
import api from "../../../utility/api/api.js";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import { Route, BrowserRouter, NavLink, Switch } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import {
  actionProcessingJobs,
  delayReasonAction,
  delayOrderAction,
} from "../../../actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { notify } from "react-notify-toast";
import loader from "../../../images/loader.gif";
class DelayReason extends React.Component {
  constructor(props) {
    super(props);
    console.log("prips", props);
    this.state = { modal: false, checked: true, isLoading: false };

    this.masterData = JSON.parse(localStorage.getItem("getMasterData"));
    this.toggle = this.toggle.bind(this);
    const history = createHistory();
    const unlisten = history.listen((location, action) => {
      if (this.state.modal) {
        this.setState({ modal: false });
      }
    });
  }
  componentWillMount() {
    api.delayreasonsList(this);
  }
  radioCheckboxChange() {
    alert("haha");
    this.setState({ error: "" });
    this.setState({ checked: !this.state.checked });
    console.log("prepre", this.state.checked);
  }
  async toggle(data, e) {
    console.log("1!!!", this.props);
    if (data === "Delay") {
      if (
        document.querySelector("input[name='delay_reason']:checked") &&
        document.querySelector("input[name='delay_time']:checked")
      ) {
        // let order_ids = localStorage.getItem("ordersArr") ? JSON.parse(localStorage.getItem("ordersArr")) : undefined;
        // if(!order_ids){
        //   notify.show('Please select a checkbox','error');
        //   return;
        // }
        // if(this.props.ordercompleted){
        //   notify.show('Order Already Completed','error')
        //     return;
        // }
        let value = document.querySelector("input[name='delay_reason']:checked")
          .value;

        let time = document.querySelector("input[name='delay_time']:checked")
          .value;
        console.log("valvalvalue", value, time);
        this.setState({ isLoading: true });
        await api.delayTrip(this.props.trip_id, value, time, this);
        this.setState({ isLoading: false });
      } else {
        this.setState({ error: "Please Select the field" });
        e.preventDefault();
        return;
      }
    }
    this.setState({
      modal: !this.state.modal,
      error: "",
    });
  }

  render() {
    if (this.props && this.props.delayData) {
      return (
        <BrowserRouter>
          <div className="delayBtn">
            <NavLink
              onClick={this.toggle}
              to="/intransit/delayorder"
              className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-cancel orange-btn"
            >
              MARK DELAY
            </NavLink>

            <Switch>
              <Route path="/intransit/delayorder">
                <Modal
                  isOpen={this.state.modal}
                  backdrop={"static"}
                  keyboard={false}
                  fade={false}
                  toggle={this.toggle}
                  className={this.props.className}
                >
                  <ModalHeader className="justify-content-center py-2 alert-secondary">
                    Reason to {this.props.label}
                  </ModalHeader>
                  <ModalBody>
                    <div className="select-reason-title">SELECT REASON</div>
                    {this.props &&
                      this.props.delayData &&
                      this.props.delayData[0].data &&
                      this.props.delayData[0].data.reasons.map((obj, key) => (
                        <div key={key}>
                          <div>
                            <input
                              className="with-gap custom-check"
                              onChange={(e) => this.setState({ error: "" })}
                              value={obj.reason}
                              id={`delay_${key}`}
                              name="delay_reason"
                              type="radio"
                            />
                            <Label htmlFor={`delay_${key}`}>{obj.reason}</Label>
                          </div>
                        </div>
                      ))}
                    <div className="select-reason-title">DELAY TIME</div>
                    {this.props &&
                      this.props.delayData &&
                      this.props.delayData[0].data &&
                      this.props.delayData[0].data.delay_time.map(
                        (obj, key) => (
                          <div key={key}>
                            <div>
                              <input
                                className="with-gap custom-check"
                                onChange={(e) => this.setState({ error: "" })}
                                value={obj}
                                id={`delay_time_${key}`}
                                name="delay_time"
                                type="radio"
                              />
                              <Label htmlFor={`delay_time_${key}`}>{obj}</Label>
                            </div>
                          </div>
                        )
                      )}
                    <div className="text-danger">{this.state.error}</div>
                  </ModalBody>
                  <ModalFooter className="p-0 border-0">
                    <span className="col-6 text-center">
                      <NavLink to="/intransit">
                        <button
                          className="btn bg-white m-0 py-2"
                          onClick={this.toggle}
                        >
                          Cancel
                        </button>
                      </NavLink>
                    </span>
                    <span className="col-6 text-center">
                      {this.state.isLoading ? (
                        <img src={loader} height="40px" />
                      ) : (
                        <div
                          className="m-0 py-2 modalbutton"
                          exact
                          to="/intransit"
                          onClick={(e) => this.toggle(this.props.label, e)}
                        >
                          OK, Done
                        </div>
                      )}
                    </span>{" "}
                  </ModalFooter>
                </Modal>
              </Route>
            </Switch>
          </div>
        </BrowserRouter>
      );
    } else {
      return (
        <div>
          <Button onClick={this.toggle}>{"Delay"}</Button>
        </div>
      );
    }
  }
}
function mapStateToProps(state) {
  console.log("delayDetails", state);
  return {
    delayData: state.getdelayreasons,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionProcessingJobs: actionProcessingJobs,
      delayReasonAction: delayReasonAction,
      delayOrderAction: delayOrderAction,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(DelayReason);



// WEBPACK FOOTER //
// ./src/components/Intransit/ViewTripList/DelayReason.js